module.exports = require("v8");